export const mockEvent = {
  id: 23,
  name: "Congreso CONAFO 2026",
  venue: "Sede Villa Mercedes",
  pointOfSale: "Puesto 03 · Hall central",
  seller: "Marina López",
  schedule: "23 sep · 08:00 a 20:00",
  status: "Activo",
};

export const mockProducts = [
  { id: 101, name: "Café", category: "Bebidas", price: 1800, emoji: "☕", accent: "#8B5E3C" },
  { id: 102, name: "Agua mineral", category: "Bebidas", price: 1500, emoji: "💧", accent: "#2C86C5" },
  { id: 103, name: "Gaseosa", category: "Bebidas", price: 2200, emoji: "🥤", accent: "#D5046D" },
  { id: 104, name: "Jugo de naranja", category: "Bebidas", price: 2100, emoji: "🍊", accent: "#F59B24" },
  { id: 201, name: "Sándwich de jamón y queso", category: "Comidas", price: 4600, emoji: "🥪", accent: "#B27835" },
  { id: 202, name: "Hamburguesa completa", category: "Comidas", price: 6800, emoji: "🍔", accent: "#C84A2F" },
  { id: 203, name: "Empanada de carne", category: "Comidas", price: 1900, emoji: "🥟", accent: "#D08B38" },
  { id: 204, name: "Porción de pizza", category: "Comidas", price: 2600, emoji: "🍕", accent: "#C94B3B" },
  { id: 301, name: "Alfajor", category: "Dulces", price: 1600, emoji: "🍪", accent: "#9B6444" },
  { id: 302, name: "Barra de cereal", category: "Dulces", price: 1400, emoji: "🌾", accent: "#7A934C" },
  { id: 303, name: "Ensalada de frutas", category: "Dulces", price: 3200, emoji: "🍓", accent: "#DE4963" },
  { id: 304, name: "Medialuna", category: "Dulces", price: 1200, emoji: "🥐", accent: "#D49A3A" },
];
export const mockCustomers = [
  {
    id: 41,
    dni: "32987456",
    firstName: "Lucía",
    lastName: "Fernández",
    communityRole: "Docente",
    isCommunityMember: true,
  },
  {
    id: 87,
    dni: "40123654",
    firstName: "Mateo",
    lastName: "Sosa",
    communityRole: "Estudiante",
    isCommunityMember: true,
  },
];

export const mockPaymentMethods = [
  { code: "posnet", label: "Posnet", icon: "credit_card", requiresSellerConfirmation: true, recommended: true },
  { code: "qr", label: "QR", icon: "qr_code_2", requiresSellerConfirmation: false },
  { code: "transfer", label: "Transferencia", icon: "account_balance", requiresSellerConfirmation: true },
  { code: "cash", label: "Efectivo", icon: "payments", requiresSellerConfirmation: true },
];

export const mockVouchers = [
  {
    code: "CAFE-1U",
    name: "Café de bienvenida",
    type: "PRODUCTO",
    productId: 101,
    units: 1,
  },
  {
    code: "BEBIDAS-2U",
    name: "Refrigerio · 2 bebidas",
    type: "CATEGORIA",
    category: "Bebidas",
    units: 2,
  },
  {
    code: "CONAFO-4000",
    name: "Voucher general · $4.000",
    type: "MONTO",
    amount: 4000,
  },
];

// Documento de impresión de la demo. Sirve para probar los renderers, la cola
// y la impresora sin backend. No fabrica un comprobante fiscal: con saldo a
// cobrar queda PENDIENTE_AFIP (sólo comanda) y con total cero imprime la
// constancia bonificada, igual que el flujo real.
export const buildMockDocumentosImpresion = ({
  saleId,
  cartItems,
  totals,
  voucher,
  seller,
  observaciones = null,
}) => {
  const lineas = cartItems.map((item, index) => ({
    idDetalle: index + 1,
    idProducto: item.id,
    nombre: item.name,
    cantidad: item.quantity,
    precioUnitario: item.price,
    subtotal: item.price * item.quantity,
    esElaborado: item.category === "Comidas",
    observacion: null,
  }));
  const total = Number(totals.amountDue || 0);
  return {
    idPedido: saleId,
    estadoFiscal: total <= 0.01 ? "NO_APLICA_TOTAL_CERO" : "PENDIENTE_AFIP",
    emisor: {
      nombre: "UPrO Comedor (demo)",
      razonSocial: "Universidad Provincial de Oficios",
      cuit: "00-00000000-0",
      domicilio: mockEvent.venue,
      condicionIva: "IVA Responsable Inscripto",
      ingresosBrutos: null,
      inicioActividades: null,
      puntoVenta: null,
    },
    factura: null,
    pedido: {
      idPedido: saleId,
      idVenta: null,
      nroPedido: String(saleId),
      fecha: new Date().toISOString(),
      evento: mockEvent.name,
      vendedor: seller,
      unidades: cartItems.reduce((sum, item) => sum + item.quantity, 0),
      subtotal: Number(totals.total || 0),
      descuento: Number(totals.voucherApplied || 0),
      total,
      voucher: voucher?.name || null,
      observaciones: observaciones || null,
    },
    lineas,
  };
};

export const mockRecentSales = [
  {
    id: "EV-0086",
    time: "11:42",
    customer: "Consumidor final",
    items: 3,
    payment: "QR",
    total: 8600,
    status: "Aprobado",
  },
  {
    id: "EV-0085",
    time: "11:38",
    customer: "Mateo Sosa",
    items: 2,
    payment: "QR",
    benefit: "Voucher general · $4.000",
    total: 5700,
    status: "Aprobado",
  },
  {
    id: "EV-0084",
    time: "11:31",
    customer: "Lucía Fernández",
    items: 1,
    payment: "Posnet",
    total: 6800,
    status: "Aprobado",
  },
  {
    id: "EV-0083",
    time: "11:24",
    customer: "Consumidor final",
    items: 4,
    payment: "Transferencia",
    total: 10400,
    status: "Aprobado",
  },
];
